import { useEffect, useRef, useState } from "react";
import { BackgroundMotion } from "./background-motion";
import type { BackgroundMotionStatus } from "./background-motion";
import type { Point } from "./game/geometry";

export interface BackgroundMotionControl {
  status: BackgroundMotionStatus;
  enable: () => void;
  disable: () => void;
}

export function useBackgroundMotion(
  onOffset: (point: Point) => void,
): BackgroundMotionControl {
  const latest = useRef(onOffset);
  latest.current = onOffset;
  const motion = useRef<BackgroundMotion | null>(null);
  const [status, setStatus] = useState<BackgroundMotionStatus>("unsupported");
  useEffect(() => {
    const controller = new BackgroundMotion(
      (point) => latest.current(point),
      setStatus,
    );
    motion.current = controller;
    controller.start();
    return () => {
      controller.destroy();
      motion.current = null;
    };
  }, []);
  return {
    status,
    enable: () => {
      void motion.current?.enable();
    },
    disable: () => motion.current?.disable(),
  };
}
